import { render } from "./MNotes.vue?vue&type=template&id=00eac927&scoped=true"
import script from "./MNotes.vue?vue&type=script&lang=js"
export * from "./MNotes.vue?vue&type=script&lang=js"

import "./MNotes.vue?vue&type=style&index=0&id=00eac927&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00eac927"]])

export default __exports__